import {Injectable} from '@angular/core';
import {HttpResponse} from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})

export class ExportFileService {
    downloadFile(action: HttpResponse<Blob>) {
        const res = action;
        const newBlob = new Blob([res.body], {type: res.body.type});
        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob);

        const link = document.createElement('a');
        link.href = data;
        // TODO get file name from headers
        // const header = Object.assign({}, res.headers.get('Content-Disposition'));
        // link.download = header.split('filename=')[1];
        link.download = 'export-report.csv';
        // this is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));

        setTimeout(() => {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
            link.remove();
        }, 100);
    }
}
